import { useRef } from 'react';
import SearchLectureSelect from "@/pcomponents/common/content/basic/student/search/search_lecture_select";
import strFunc from '@/lib/lyg/string';

function SearchArea(props: any) {
  let myProps = {
    listOpt: {},
    setListOpt: (inData: any) => { },
    list: (inData: any) => { },
    xColumnArr: {},
    ...props
  };
  let listOpt = myProps.listOpt;
  let xColumnArr = myProps.xColumnArr;

  const handleInputChange = (event: any) => {
    const target = event.target;
    let value = target.value;
    const name = target.name;
    if (target.type === 'checkbox' || target.type === 'radio') {
      value = "";
      if (target.checked) {
        value = target.value;
      }
    }
    let change_listOpt: any = {
      ...listOpt,
    };
    change_listOpt[name] = value;

    let tag_name = target.tagName.toLowerCase();
    if (tag_name == "select" || target.type == "checkbox" || target.type == "radio") {
      myProps.list({ ...change_listOpt, now_page: 1 });
    } else {
      myProps.setListOpt(change_listOpt);
    }
  };

  return (
    <div>
      <div className='my_flex_left'>
        <SearchLectureSelect
          name="s_stu_lecture_seq"
          value={listOpt.s_stu_lecture_seq}
          on_change_input={(inData: any) => {
            let name = inData.name;
            let value = inData.value;
            myProps.list({ now_page: 1, [name]: value });
          }}
          wrap_style={{ width: 90, display: "inline-table" }}
          select_title_style={{ lineHeight: "28px", height: 28, overflow: "hidden" }}
        ></SearchLectureSelect>
        <select className="search-input" name="s_stu_grade" value={listOpt.s_stu_grade}
          onChange={handleInputChange} >
          <option value="">학년</option>
          {xColumnArr.select_arr["a_stu_grade"].map((item: any, idx: number) => {
            return (
              <option key={idx} value={item.value} >{item.text}</option>
            );
          })}
        </select>
        <input type="text" className="search-input" name="s_search_text"
          style={{ width: 80 }} placeholder="이름" value={listOpt.s_search_text}
          onChange={handleInputChange}
          autoComplete='off'
          onKeyUp={(e: any) => { myProps.list({ "now_page": 1 }); }} />
        <label>
          <input type="checkbox" className="search-input" name="s_addon_study_map_s_order_recent"
            checked={listOpt.s_addon_study_map_s_order_recent == "1"} value={"1"}
            onChange={handleInputChange} />
          맵핑 정렬
        </label>
        <button className="btn btn-dark" onClick={() => { myProps.list({ "now_page": "1" }); }}>검색</button>
      </div>
    </div>
  );
};
export default SearchArea;